import React, { memo, useEffect, useRef, useState } from 'react';
import { ErrorInput as StorybookErrorInput } from '@sunbeltrentals/sbr-global-components';
import { DIGIT_REGEX } from '../../../../global/utils/commonUtils';
import './numberVerification.scss';

const OtpInput = ({ length = 6, onOtpSubmit = () => {}, otpError, onInputFieldFocus }) => {
    const [otp, setOtp] = useState(new Array(length).fill(''));
    const inputRefs = useRef([]);

    useEffect(() => {
        if (inputRefs.current[0]) {
            inputRefs.current[0].focus();
        }
    }, []);

    const handleChange = (index, e) => {
        const value = e.target.value.replace(DIGIT_REGEX, '');
        const newOtp = [...otp];
        // allow only one input
        newOtp[index] = value;
        setOtp(newOtp);
        // submit trigger
        const combinedOtp = newOtp.join('');
        onOtpSubmit(combinedOtp);
        // Move to next input if current field is filled
        if (value && index < length - 1 && inputRefs.current[index + 1]) {
            inputRefs.current[index + 1].focus();
        }
    };

    const handleClick = index => {
        inputRefs.current[index].setSelectionRange(1, 1);
    };

    const handleKeyDown = (index, e) => {
        if (e.key === 'Backspace' && !otp[index] && index > 0 && inputRefs.current[index - 1]) {
            // Move focus to the previous input field on backspace
            inputRefs.current[index - 1].focus();
        }
    };

    return (
        <div className="otpInput__wrapper">
            <div className="otpInput__container">
                {otp.map((value, index) => {
                    return (
                        <input
                            key={index}
                            ref={input => (inputRefs.current[index] = input)}
                            value={value}
                            onChange={e => handleChange(index, e)}
                            onClick={() => handleClick(index)}
                            onKeyDown={e => handleKeyDown(index, e)}
                            maxLength={1}
                            onFocus={() => onInputFieldFocus()}
                            data-testid={`otp-input-${index}`}  
                            className={`cmp-Field__field__input otpInput  ${otpError ? 'error_input__border' : ''}`}
                        />
                    );
                })}
            </div>
            <StorybookErrorInput errorMsg={otpError} />
        </div>
    );
};

export default memo(OtpInput);
